import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { RequestModalProvider } from "@/context/RequestModalContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import DestinationPage from "@/pages/DestinationPage";
import ServiceCityPage from "@/pages/ServiceCityPage";
import ServicesHub from "@/pages/ServicesHub";
import { ALL_LANDINGS } from "@/lib/seoPages";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <RequestModalProvider>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/destinations/:slug" element={<DestinationPage />} />
                <Route path="/services" element={<ServicesHub lang="en" />} />
                <Route path="/es/servicios" element={<ServicesHub lang="es" />} />
                {ALL_LANDINGS.map((l) => (
                  <Route key={l.path} path={l.path}
                    element={<ServiceCityPage serviceId={l.serviceId} cityId={l.cityId} lang={l.lang} />} />
                ))}
                <Route path="/admin/login" element={<Login />} />
                <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              </Routes>
              <Toaster position="top-center" theme="dark" />
            </RequestModalProvider>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
